module.exports = __webpack_public_path__ + "img/icon-docs2.c869299e.svg";